import * as Sentry from '@sentry/astro'
Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  sendDefaultPii: false,
  integrations: [],
})
